// extracted by mini-css-extract-plugin
export var chevronIcon = "_sl-1";
export var edgeToggle = "_sl-0";